// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderForm_wrapper__ZPbH5","btn":"OrderForm_btn__m2r9k"};